import React from "react";
import { HelpModalWindow } from "../HelpModalWindow";

export const HelpModal: React.FC<{
  onModalClose: () => void;
}> = ({ onModalClose }) => (
  <HelpModalWindow
    onCloseClick={onModalClose}
    cards={
      <>
        <div>
          <h2>Правила цветного судоку</h2>
          <p>
            Заполни поле 6 × 6 шестью цветами. В каждой строке, каждом столбце
            и каждом блоке из 2 строк и 3 столбцов каждый цвет должен встречаться
            ровно один раз.
          </p>
        </div>
        <div>
          <h2>Как выбрать цвет</h2>
          <p>
            Нажми на пустую клетку, затем выбери цвет на палитре справа.
            Чтобы исправить свой ход, выбери эту клетку и другой цвет.
            Цвета, заданные в начале игры, менять нельзя.
          </p>
        </div>
        <div>
          <h2>Проверка решения</h2>
          <p>
            Кнопка «Проверить» покажет ошибки или количество оставшихся пустых
            клеток. Заполни всё поле правильно, чтобы победить!
          </p>
        </div>
      </>
    }
  />
);
